import { styled } from '@mui/material';

import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

export const StyledContainer = styled('div')<{ showBorderBox: boolean }>(
  ({ showBorderBox, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    ...(showBorderBox && {
      // TODO: no VDS token for this value — needs designer input (#252a36)
      border: '1px solid #252a36',
      borderRadius: borderRadius.sm,
      padding: '7px 4px',
      backgroundColor: theme.palette.background.paper,
      boxSizing: 'border-box',
      // TODO: VDS (StyledContainer) - dimension token pending -- Barry
      height: 56,
    }),
  })
);
